// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd830627","239":"efc3c426","455":"d0731e60","488":"13ab058e"}[chunkId] + ".chunk.js";
};